var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.info
    ? _c(
        "div",
        { staticClass: "s-guidance", staticStyle: { color: "#999999" } },
        [
          _vm._v("\n  " + _vm._s(_vm.info) + "\n  "),
          _vm.image
            ? _c(
                "el-popover",
                { attrs: { placement: "top-start", trigger: "hover" } },
                [
                  _c("div", { staticClass: "s-guidance-pop" }, [
                    _vm.url
                      ? _c("div", [
                          _c("div", [_vm._v("更多详情请查看：")]),
                          _vm._v(" "),
                          _c("a", { attrs: { href: _vm.url } }, [
                            _vm._v(_vm._s(_vm.url)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", { attrs: { src: _vm.image, alt: "示例" } }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "tip",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    },
                    [_vm._v("查看示例")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }